import { useState, useEffect, useContext } from 'react'
import { sileo } from 'sileo'
import { CentroCostosAPI } from '../../../../../../api/centroCostos.api'
import GlobalContext from '../../../../../../context/global-context'

import CrearCentro from './CrearCentro'
import ListCentroCostos from './ListCentroCostos'

const Index = () => {
  const centroCostosAPI = new CentroCostosAPI()
  const [centroCostos, setCentroCostos] = useState([])
  const { currentBusiness } = useContext(GlobalContext)

  const getCentroCostos = async () => {
    try {
      const response = await centroCostosAPI.getCentroCostos(currentBusiness.id)
      setCentroCostos(response.data)
    } catch (error) {
      console.error('Error al cargar los datos:', error)
      throw error
    }
  }

  const createCentroCostos = async name => {
    try {
      await sileo.promise(
        centroCostosAPI.postCreate(currentBusiness.id, { name }), // body { name: '...' }
        {
          loading: { title: 'Escribiendo' },
          success: {
            title: '¡Listo!',
            description: (
              <span className='text-green-500/80 font-medium'>Centro de costos creado 👌</span>
            )
          },
          error: {
            title: 'Error de Creación',
            description: 'No se pudo crear el centro de costos 🤯'
          }
        }
      )

      // refrescar la lista
      await getCentroCostos()
    } catch (error) {
      console.error('Error al crear el centro de costos:', error)
    }
  }

  useEffect(() => {
    const cargarDatos = async () => {
      await sileo.promise(getCentroCostos(), {
        loading: { title: 'Cargando Datos' },
        success: {
          title: '¡Listo!',
          description: (
            <span className='text-green-500/80 font-medium'>Datos cargados exitosamente... 👌</span>
          )
        },
        error: {
          title: 'Error al Cargar',
          description: 'No se pudieron cargar los datos 🤯'
        }
      })
    }

    cargarDatos()
  }, [])

  const deleteCentroCosto = async idCentroCosto => {
    try {
      await sileo.promise(
        centroCostosAPI.deleteCentroCosto(currentBusiness.id, idCentroCosto), // 👈 ajusta la URL según tu back
        {
          loading: { title: 'Eliminando' },
          success: {
            title: '¡Borrado!',
            description: (
              <span className='text-green-500/80 font-medium'>Centro de costos eliminado 👌</span>
            )
          },
          error: {
            title: 'Error al Eliminar',
            description: 'No se pudo eliminar el centro de costos por encontrarse en uso 🤯'
          }
        }
      )
      await getCentroCostos()
    } catch (error) {
      console.error('Error al eliminar el centro de costos:', error)
    }
  }

  return (
    <div
      style={{ height: 'calc(100vh - 12rem)' }}
      className='p-4 flex flex-col gap-4 font-sans min-h-0'
    >
      {/* Componente para CREAR */}
      <div className='shrink-0'>
        <CrearCentro onCreate={createCentroCostos} />
      </div>

      {/* Componente para LISTAR */}
      <div className='flex-1 min-h-0 overflow-y-auto'>
        <ListCentroCostos
          centroCostos={centroCostos}
          onDelete={deleteCentroCosto}
          onRefresh={getCentroCostos}
        />
      </div>
    </div>
  )
}

export default Index
